// extracted by mini-css-extract-plugin
export default {"headerTitle":"header_headerTitle__THiso","headerTitle__pace":"header_headerTitle__pace__8auyq"};